

    <header class="header">
        <div class="header_inner">
            <div class="headerMain">
                <div class="headerMain_logo"><a href="https://jp.visitozu.com/"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/pic_logo2.svg?v=2" alt="おおず 四国愛媛・大洲"></a></div>

                <div class="headerMain_right">
                    <div class="headerMain_right-left">
                        <div class="headerMain_top">
                            <ul class="headerMain_top-list">
                                <li><a href="https://jp.visitozu.com/travel_agency">旅行業者の皆さまへ</a></li>
                                <li><a href="https://www.visitozu.com/en-gb" target="_blank" rel="noopener">English</a></li>
                            </ul>
                            <div class="headerMain_top-btm">
                                <div class="headerMainNavi">
                                    <div class="headerMainNavi_item"><a href="https://jp.visitozu.com/blog/">お知らせ</a></div>
                                    <div class="headerMainNavi_item"><a href="https://jp.visitozu.com/about/">大洲について</a></div>
                                    <div class="headerMainNavi_item"><a href="https://jp.visitozu.com/feature/">特集</a></div>
                                    <div class="headerMainNavi_item"><a href="https://jp.visitozu.com/highlight/">観光スポット</a></div>
                                    <div class="headerMainNavi_item"><a href="https://jp.visitozu.com/inn/">大洲のお宿</a></div>
                                    <div class="headerMainNavi_item"><a href="https://jp.visitozu.com/access/">アクセス</a></div>
                                </div>
                            </div>
                        </div>
                        <!-- /.headerMainNavi -->
                    </div>
                    <div class="headerMain_right-right">
                        <ul class="headerMain_right-list">
                            <li><a href="https://jp.visitozu.com/booking/">ご予約/ご購入</a></li>
                            <li><a href="http://ozuukai.com/" rel="noopener noreferrer">大洲のうかいをご予約</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- /.headerMain -->
    </header>
    <!-- /.header -->




    <div class="headerWrap">
                    <div class="subPageHeader" id="js-sub-logo">
            <div class="subPageHeader_logo">
                <a href="https://jp.visitozu.com/">
                    <img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/pic_logo4.svg?v=2" alt="おおず 四国愛媛・大洲" class="subPageHeader_logo-img01">
                </a>
            </div>
            <div class="subPageHeader_right">
                <!--<div class="subPageHeader_lang">日本語</div>-->
                <!-- <div class="subPageHeader_search"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_search_02.svg?v=2" alt=""></div> -->
            </div>
        </div>
        <div class="subreserve">
            <a href="https://jp.visitozu.com/booking/" rel="noopener noreferrer">
                <span class="reserve-text">ご予約/ご購入</span>
            </a>
        </div>
        <div class="subreserve_ukai">
            <a href="http://ozuukai.com/" rel="noopener noreferrer">
                <span class="reserve-text">大洲のうかい/ご予約</span>
            </a>
        </div>
        <!-- /.subPageLogo -->
                </div>
    <!-- /.headerWrap -->


            <div class="mainLogo_search mainLogo_search-01"><a href="/pagesearch/"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_search_parts.svg?v=2" alt="おおず 四国愛媛・大洲"></a></div>
            <div class="spreserve">
        <a href="https://jp.visitozu.com/booking/" rel="noopener noreferrer">
            <span class="reserve-text">ご予約/ご購入</span>
        </a>
    </div>
    <div class="spreserve_ukai">
        <a href="http://ozuukai.com/" rel="noopener noreferrer">
            <span class="reserve-text">大洲のうかい/ご予約</span>
        </a>
    </div>

    <div class="menuBtn"><span></span><span></span><span></span></div>

    <div class="menuContainer">
        <div class="menuContainer_wrap">
            <div class="menuContainer_inner">
                <div class="menuContainer_logo"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/pic_logo.svg?v=2" alt="おおず 四国愛媛・大洲"></div>

                <div class="menuContainerMain">

                    <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/">トップページ</a></dt>
                    </dl>

                    <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/blog/">お知らせ</a></dt>
                    </dl>

                    <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/about/">大洲について</a></dt>
                    </dl>
                    <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/feature/">特集</a></dt>
                    </dl>
                    <dl class="menuContainerMain_item menuContainerMain_item-more">
                        <dt><a href="https://jp.visitozu.com/highlight/">観光スポット</a></dt>
                        <dd>
                            <ul class="menuContainerMain_list">
                                <li><a href="https://jp.visitozu.com/highlight/">市内全域</a></li>
                            </ul>
                        </dd>
                    </dl>

                    <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/inn/">大洲のお宿</a></dt>
                    </dl>

                    <dl class="menuContainerMain_item menuContainerMain_item-more">
                        <dt><a href="https://jp.visitozu.com/access/">アクセス</a></dt>
                        <dd>
                            <ul class="menuContainerMain_list">
                                <li><a href="https://jp.visitozu.com/access/tokyo/">東京からのアクセス</a></li>
                                <li><a href="https://jp.visitozu.com/access/kyoto_osaka/">京都・大阪・神戸からのアクセス</a></li>
                                <li><a href="https://jp.visitozu.com/access/nagoya/">名古屋からのアクセス</a></li>
                                <li><a href="https://jp.visitozu.com/access/hiroshima/">広島からのアクセス</a></li>
                                <li><a href="https://jp.visitozu.com/access/other/">その他地域からのアクセス</a></li>
                                <li><a href="https://jp.visitozu.com/access/city/">大洲市内・お車でお越しの方</a></li>
                            </ul>
                        </dd>
                    </dl>

                    <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/booking/index.html?lang=ja&amp;fbclid=IwAR2e4JhcXfYL_BljpgIeJHeAdCwpaOIVdoTWA2s2jdZo6pYW0PF2lWnhr98">予約する</a></dt>
                    </dl>

                    <dl class="menuContainerMain_item menuContainerMain_item-more">
                        <dt><a href="https://jp.visitozu.com/travel_agency/">旅行業者の皆さまへ</a></dt>
                        <dd>
                            <ul class="menuContainerMain_list">
                                <li><a href="https://jp.visitozu.com/travel_agency/">旅行業者の皆さまへ</a></li>
                                <li><a href="https://jp.visitozu.com/travel_agency/about/">大洲のサステナブルツーリズム</a></li>
                                <li><a href="https://jp.visitozu.com/travel_agency/request/">テーラーメイドツアーについての資料請求・お問い合わせ</a></li>
                            </ul>
                        </dd>
                    </dl>


                    <!--
                    <dl class="menuContainerMain_item menuContainerMain_item-more">
                        <dt><a href="https://jp.visitozu.com/story/">大洲の魅力</a></dt>
                        <dd>
                            <ul class="menuContainerMain_list">
                                <li><a href="https://jp.visitozu.com/story/nature/">水郷の自然</a></li>
                                <li><a href="https://jp.visitozu.com/story/history/">伝統文化・歴史</a></li>
                                <li><a href="https://jp.visitozu.com/story/gourmet/">城下町の美味</a></li>
                            </ul>
                        </dd>
                    </dl>
-->


                    <!-- <dl class="menuContainerMain_item">
                        <dt><a href="https://jp.visitozu.com/experience/">大洲での過ごし方</a></dt>
                    </dl> -->





                </div>
                <!-- /.menuContainerMain -->

                <div class="menuContainerMainSub">
                    <div class="menuContainerMainSub_item">
                        <a href="https://jp.visitozu.com/tax_payment/">大洲の土産もの</a>
                    </div>
                    <div class="menuContainerMainSub_item">
                        <a href="https://hana.visitozu.com/" target="_blank">まち歩き「おおず歴史華回廊」</a>
                    </div>
                </div>
                <!-- /.menuContainerMainSub -->


                <div class="menuContainerMainSub02">
                    <div class="menuContainerMainSub02_left">
                        <ul class="menuContainerMainSub02_list">
                            <li><a href="https://jp.visitozu.com/guide/link/">外部リンク</a></li>
                            <li><a href="https://jp.visitozu.com/guide/contact/">お問い合わせ</a></li>
                            <li><a href="https://jp.visitozu.com/sitemap/">サイトマップ</a></li>
                            <li><a href="https://jp.visitozu.com/guide/">このサイトをご利用にあたって</a></li>
                            <li><a href="https://www.visitozu.com/en-gb" target="_blank">English</a></li>
                        </ul>

                    </div>
                    <div class="menuContainerMainSub02_right">
                        <ul class="menuContainerMainSub02_sns">
                            <li><a href="https://www.instagram.com/visit_ozu/" target="_blank"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_footer_01.svg?v=2" alt=""></a></li>
                            <!--<li><a href="https://twitter.com/Visit_ozu" target="_blank"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_footer_02.svg?v=2" alt=""></a></li>-->
                            <li><a href="https://www.facebook.com/visitozu" target="_blank"><img src="https://jp.visitozu.com/wp/wp-content/themes/oozushi-theme/cmn/img/common/icon_footer_03.svg?v=2" alt=""></a></li>
                        </ul>

                    </div>
                </div>
                <!-- /.menuContainerMainSub02 -->



            </div>
        </div>
    </div>
    <!-- /.menuContainer -->



<!-- /.subPageSection -->
